import { useReducer } from 'react';
import useRouteUserViewContext from '../WebappChatUI/hooks/useUserViewContext';
import UserViewContextContext from './UserViewContextContext';
import mergeUserViewContext from './helpers/mergeUserViewContext';
import reduceUserViewContextContribution from './helpers/reduceUserViewContextContribution';
import type { UserViewContextProviderProps } from './types';

const UserViewContextProvider = ({ children }: UserViewContextProviderProps) => {
    const baseContext = useRouteUserViewContext();
    const [scopedContribution, dispatchContribution] = useReducer(
        reduceUserViewContextContribution,
        null
    );
    const userViewContext = mergeUserViewContext({
        baseContext,
        contribution: scopedContribution?.contribution ?? null,
    });

    return (
        <UserViewContextContext.Provider value={{ userViewContext, dispatchContribution }}>
            {children}
        </UserViewContextContext.Provider>
    );
};

export default UserViewContextProvider;
